/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Resolves a Mongo ObjectId hex string from soul-like objects used across the app.
 * Supports Extended JSON ({ _id: { $oid } }), plain string _id, and match rows ({ otherSoulId }).
 */
export function getSoulOid(soul: any): string | null {
  if (soul == null) {
    return null;
  }

  const id = soul._id;
  if (id != null) {
    if (typeof id === 'string' && id.length > 0) {
      return id;
    }
    if (typeof id === 'object' && typeof id.$oid === 'string' && id.$oid.length > 0) {
      return id.$oid;
    }
  }

  const otherSoulId = soul.otherSoulId;
  if (otherSoulId != null) {
    if (typeof otherSoulId === 'string' && otherSoulId.length > 0) {
      return otherSoulId;
    }
    if (typeof otherSoulId === 'object' && typeof otherSoulId.$oid === 'string' && otherSoulId.$oid.length > 0) {
      return otherSoulId.$oid;
    }
  }

  return null;
}

export function hasSoulOid(soul: any): boolean {
  return getSoulOid(soul) != null;
}
